<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li class="flex items-center">
            <router-link to="/inventory/goodsreceipt" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("inventory.label.ViewGoodsReceipt") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("inventory.label.id") }}</b>
                </td>
                <td>{{ good.id }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("inventory.label.Purchase Date") }}</b>
                </td>
                <td>{{ good.purchaseDate | formatedate }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("inventory.label.Supplier Code") }}</b>
                </td>
                <td>{{ good.supplierName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("inventory.label.Item Description") }}</b>
                </td>
                <td>{{ good.itemDescription }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("inventory.label.Ordered Quantity") }}</b>
                </td>
                <td>{{ good.orderdQuantity }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("inventory.label.Received Quantity") }}</b>
                </td>
                <td>{{ good.receivedQuantity }}</td>
              </tr>
              <tr>
                <td class="border-none">
                  <b>{{ $t("inventory.label.Balance Quantity") }}</b>
                </td>
                <td class="border-none">{{ good.balanceQuantity }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { getByIdGood } from "@/http/inventory";
import moment from "moment";
export default {
  data() {
    return {
      good: {},
    };
  },

  computed: {},
  methods: {
    async getByIdGood() {
      try {
        const response = await getByIdGood(this.id);
        this.good = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getByIdGood();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
